import { Type } from '@angular/core';

import {
  SiteContext,
  LANGUAGE_CONTEXT_ID, LanguageService,
  CURRENCY_CONTEXT_ID, CurrencyService,
  BASE_SITE_CONTEXT_ID, BaseSiteService
} from '@spartacus/core';

import { CUSTOM_LANGUAGE, CUSTOM_BRAND } from '../../constants/custom-context';
import { CustomLanguageService } from '../../services/custom-language.service';
import { CustomBrandService } from '../../services/custom-brand.service';

export const appInitServiceMap = (): { [context: string]: Type<SiteContext<any>> } => ({
  [LANGUAGE_CONTEXT_ID]: LanguageService,
  [CURRENCY_CONTEXT_ID]: CurrencyService,
  [BASE_SITE_CONTEXT_ID]: BaseSiteService,
  [CUSTOM_LANGUAGE]: CustomLanguageService,
  [CUSTOM_BRAND]: CustomBrandService
});
